import { ProductTier, ProductTier_index } from '@weave/schema-gen-ts/dist/shared/call-intelligence/plg/product.pb';

export const hasCallIntelPlanAccess = (currentPlan?: ProductTier) => {
  if (!currentPlan) {
    return false;
  }

  return ProductTier_index[currentPlan] > ProductTier_index[ProductTier.PRODUCT_TIER_UNSPECIFIED];
};

export const canUseCallIntelPremiumFeatures = (currentPlan?: ProductTier) => {
  if (!currentPlan) {
    return false;
  }

  return ProductTier_index[currentPlan] >= ProductTier_index[ProductTier.PRODUCT_TIER_PRO];
};
